import generalListMIZ from "./generalListMIZ.js";

export default [...generalListMIZ];
